module.exports = __webpack_public_path__ + "img/salidaRuta.21dc74a7.svg";